// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Log di Amigo',
  intro:
    "Ogni richiesta gestita da Amigo: cosa è stato chiesto, dove, chi l'ha fatta e chi l'ha approvata. Solo FoodAmigos vede questa pagina.",
  // The tab list's name for screen readers.
  tabs_label: 'Log di Amigo',
  tabs: {
    requests: 'Richieste',
    gaps: 'Non eseguibili',
  },
  filters: {
    restaurant: 'Ristorante',
    all_restaurants: 'Tutti i ristoranti',
    brand: '{{name}} · Brand',
    restaurant_unknown: 'Ristorante {{id}}',
    searching: 'Cerco ristoranti…',
    no_restaurant: 'Nessun ristorante chiamato “{{query}}”',
    period: 'Periodo',
    start_date: 'Data di inizio',
    end_date: 'Data di fine',
    refresh: 'Aggiorna',
    gap: 'Richiesta: {{request}}',
    change_set: "La richiesta all'origine di una modifica",
    remove: 'Rimuovi il filtro: {{label}}',
    clear: 'Cancella filtri',
  },
  columns: {
    steps: 'Passaggi',
    when: 'Quando',
    request: 'Richiesta',
    restaurant: 'Ristorante',
    asked_by: 'Richiesta da',
    result: 'Esito',
  },
  show_steps: 'Mostra i passaggi di: {{request}}',
  approved_by: 'Approvato da {{name}}',
  nothing_approved: 'Nulla di approvato',
  results: {
    applied: '{{applied}} applicate',
    applied_skipped: '{{applied}} applicate · {{skipped}} saltate',
    partial: '{{applied}} di {{total}} applicate',
    imported: 'Importato',
    importing: 'Importazione in corso',
    waiting: 'In attesa di approvazione',
    rejected: 'Rifiutato',
    undone: 'Annullato',
    expired: 'Scaduto',
    replaced: 'Sostituito',
    failed: 'Non riuscito',
    answered: 'Risposto',
    not_yet: 'Non ancora possibile',
    off_limits: 'Non consentito',
    not_allowed: 'Non permesso',
    switched_off: 'Disattivato',
    guard: 'Bloccato da un controllo di sicurezza',
    not_found: 'Non trovato',
  },
  steps: {
    asked: '{{name}} ha chiesto',
    asked_anonymous: 'Richieste',
    approved: 'Approvato da {{name}}',
    approved_alone: 'Approvato',
    applied_one: '{{count}} modifica applicata',
    applied_other: '{{count}} modifiche applicate',
    failed_one: '{{count}} non applicate',
    failed_other: '{{count}} non applicate',
    rejected: 'Rifiutato',
    undone: 'Annullato',
    skipped_one: '{{count}} saltati',
    skipped_other: '{{count}} saltati',
    skipped_state: 'Saltato',
    more_one: 'e altri {{count}}',
    more_other: 'e altri {{count}}',
    changes_one: '{{count}} modifica',
    changes_other: '{{count}} modifiche',
    other: 'Verifica in corso',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} passo',
    steps_other: '{{count}} passi',
    refused_one: '{{count}} rifiutati',
    refused_other: '{{count}} rifiutati',
    failed_one: '{{count}} non riusciti',
    failed_other: '{{count}} non riusciti',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Esito',
    answered: 'Una risposta: nulla è cambiato.',
    waiting: 'In attesa di approvazione. Per ora nulla è cambiato.',
    rejected: 'Rifiutato: nulla è cambiato.',
    expired: 'Scaduto senza approvazione: nulla è cambiato.',
    replaced: 'Sostituito da una scheda più recente: qui nulla è cambiato.',
    undone: 'Annullato: le modifiche sono state ripristinate.',
    failed: 'Non riuscito: nulla è cambiato.',
    not_yet: 'Non ancora possibile: nulla è cambiato. Conteggiato in «Non eseguibili».',
    off_limits: 'Non consentito: nulla è cambiato.',
    not_allowed: 'Non consentito per il ruolo di questa persona: nulla è cambiato.',
    switched_off: 'Disattivato qui: nulla è cambiato.',
    guard: 'Bloccato da un controllo di sicurezza: nulla è cambiato.',
    not_found: 'Non trovato: nulla è cambiato.',
    importing: 'Importazione in corso. Ogni piatto va in Menu → Cronologia modifiche.',
    imported: 'Importato. Ogni piatto è in Menu → Cronologia modifiche.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} modifica',
    title_other: '{{count}} modifiche',
    show_all: 'Mostra tutte le {{count}} modifiche',
    show_fewer: 'Mostra meno',
    from: 'da',
    to: 'a',
    removed: 'Rimosso',
  },
  row_states: {
    skipped: 'Saltato',
    failed: 'Non applicato',
    stale: 'Modificato nel frattempo',
    kept: 'Lasciato invariato',
  },
  menu_history: 'Apri Menu → Cronologia modifiche',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Apri la chat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Impossibile aprire quel ristorante. Riprova.',
  pagination: {
    label: 'Pagine',
    summary: '{{from}}–{{to}} di {{total}} richieste',
    previous: 'Pagina precedente',
    next: 'Pagina successiva',
  },
  empty: {
    title: 'Nessuna richiesta per {{restaurant}} in questo periodo',
    text: 'Amigo non ha gestito nulla lì tra il {{from}} e il {{to}}.',
    title_any_day: 'Ancora nessuna richiesta per {{restaurant}}',
    text_any_day: 'Amigo non ha ancora gestito nulla lì.',
    title_everywhere: 'Nessuna richiesta in questo periodo',
    text_everywhere: 'Amigo non ha gestito nulla tra il {{from}} e il {{to}}.',
    title_nothing: 'Ancora nessuna richiesta',
    text_nothing: 'Amigo non ha ancora gestito nulla.',
  },
  loading: 'Caricamento…',
  error: {
    title: 'Impossibile caricare il log',
    text: 'Riprova tra un momento.',
    retry: 'Riprova',
  },
  gaps: {
    intro:
      'Ciò che Amigo non ha ancora potuto fare, raggruppato per richiesta, dalle più frequenti. Le richieste non consentite o non permesse a un ruolo non compaiono qui.',
    columns: {
      area: 'Area',
      request: 'Cosa è stato chiesto',
      count: 'Richieste',
      last_at: 'Ultima richiesta',
      requests: 'Richieste',
    },
    count: '{{count}}×',
    see_requests_one: 'Vedi {{count}} richiesta',
    see_requests_other: 'Vedi {{count}} richieste',
    today: 'Oggi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    empty_title: 'Nessuna richiesta che Amigo non abbia potuto gestire',
    empty_text: 'Amigo ha potuto gestire tutto ciò che le persone hanno chiesto.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Orari di apertura',
    order_settings: 'Impostazioni ordini',
    my_info: 'I miei dati',
    marketing: 'Marketing',
    gift_cards: 'Carte regalo',
    reports: 'Report',
    website: 'Sito web',
    integrations: 'Integrazioni',
    delivery: 'Consegna',
    payments: 'Pagamenti',
    team: 'Team',
    billing: 'Fatturazione',
    settings: 'Impostazioni',
    other: 'Altro',
  },
};
